import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { KeyRound, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Field } from "../components/common/Ui";

function Shell({ title, sub, children }) {
  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8 reveal">
        <img src="/logo-yumanabu.jpg" alt="YLMS" className="h-16 w-16 object-contain mb-4" />
        <h1 className="font-heading text-2xl font-bold text-slate-900">{title}</h1>
        <p className="text-sm text-slate-500 mt-1">{sub}</p>
        <div className="mt-6">{children}</div>
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900"><ArrowLeft className="h-3.5 w-3.5" />Kembali ke halaman masuk</Link>
      </div>
    </div>
  );
}

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setDone(true); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Lupa kata sandi" sub="Masukkan email akun Anda. Kami akan mengirim tautan untuk mengatur ulang kata sandi.">
      {done ? <div className="rounded-md bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-800 flex gap-2" data-testid="forgot-success"><CheckCircle2 className="h-5 w-5 shrink-0" /><p>Jika email <b>{email}</b> terdaftar, tautan reset telah dikirim. Periksa inbox/spam Anda. Tautan berlaku 30 menit.</p></div>
        : <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email"><Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus /></Field>
          {err && <p className="text-sm text-red-600" data-testid="forgot-error">{err}</p>}
          <Button data-testid="forgot-submit-button" type="submit" className="w-full h-10 bg-slate-900" disabled={busy}>{busy ? "Mengirim..." : "Kirim tautan reset"}</Button>
        </form>}
    </Shell>
  );
}

export function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw.length < 8) return setErr("Kata sandi minimal 8 karakter");
    if (pw !== pw2) return setErr("Konfirmasi kata sandi tidak sama");
    setBusy(true);
    try { const { data } = await api.post("/auth/reset-password", { token, password: pw }); setDone(data.email); setTimeout(() => nav("/login"), 2500); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Atur ulang kata sandi" sub="Buat kata sandi baru untuk akun Anda (minimal 8 karakter).">
      {done ? <div className="rounded-md bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-800 flex gap-2" data-testid="reset-success"><CheckCircle2 className="h-5 w-5 shrink-0" /><p>Kata sandi untuk <b>{done}</b> berhasil diubah. Mengarahkan ke halaman masuk...</p></div>
        : <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="Kata sandi baru"><Input data-testid="reset-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} autoFocus autoComplete="new-password" /></Field>
          <Field label="Ulangi kata sandi"><Input data-testid="reset-password2-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={8} autoComplete="new-password" /></Field>
          {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
          <Button data-testid="reset-submit-button" type="submit" className="w-full h-10 bg-slate-900" disabled={busy}><KeyRound className="h-4 w-4 mr-1" />{busy ? "Menyimpan..." : "Simpan kata sandi baru"}</Button>
        </form>}
    </Shell>
  );
}
